import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, tap} from 'rxjs';
import {Router} from '@angular/router';
import { toast } from '@spartan-ng/brain/sonner';
import {TranslateService} from '@ngx-translate/core';
import {AuthMyService} from '../auth/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private _authService: AuthMyService,
        private _router: Router,
        private translateService: TranslateService,
    ) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap({ error: error => this.handleError(req, error) }),
        );
    }

    handleError(req: HttpRequest<any>, event: any) {
        const exceptions = [
            'auth/password',
            'password',
            'status',
            'sign-in',
            'register',
            'wages',
            'current',
            '/api/user',
            'specification',
            'parse',
            'download',
            'municipalities',
            'enum',
            'contracts',
            'properties',
            'locations',
            'orders',
            'users',
        ];

        if (req.url.includes('municipalities') || req.url.includes('locations')) {
            return;
        }


        if (event?.error?.message && event?.status !== 401 && event?.status !== 404) {
            const errorMessage = event.error.message;
            if (errorMessage !== 'Unauthenticated.') {
                toast.error(this.translateService.instant(errorMessage) || errorMessage);
            }
        }

        for (const exception of exceptions) {
            if (req.url.includes(exception)) {
                return;
            }
        }

        if (event.status === 500) {
            if (event?.error?.message === 'Unauthenticated.') {
                toast.error(this.translateService.instant('section.auth.error_signout'));
                this._authService.signOut().subscribe();
                this._router.navigate(['/sign-in']).then();
                location.reload();
            } else {
                this._router.navigate(['/500-internal-server-error']).then();
            }
        }

        if (event.status === 404) {
            if (this._router.url.startsWith('/leads/') || req.url.includes('/leads')) {
                this._router.navigate(['/leads']).then();
            } else {
                this._router.navigate(['/404-not-found']).then();
            }
        }
        if (event.status === 503) {
            this._router.navigate(['/maintenance']).then();
        }
    }
}
